<template>
	<div>
		<div class="table_description table_description_filter padding_bottom_s">
			<span>{{ $t("debtor.ipuTableWithFilter.disclaimer") }}</span>
		</div>
		<div class="table_head table_head_filter">
			<div class="flex flex_start">
				<QuickEnumFilterGroup column-name="status"
									  :enum-def="enumDef.ipuRequestStatus"
									  :option-values="[
										  enumDef.ipuRequestStatus.Requested,
										  enumDef.ipuRequestStatus.Approved
									  ]"
									  :default-value="enumDef.ipuRequestStatus.Requested"
									  @apply-filter="applyQuickFilter"
									  storage-key="ipu.status"
				/>
				<md-button class="md-blank" @click="showConfirm">
					<i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
					{{ $t("DebtorIpuTableWithFilter.btn.text") }}
				</md-button>
			</div>
		</div>
		<div class="flex filter_table">
			<div class="flex flex_column w_100">
				<ag-item
					v-on:getGridApi="getGridApi"
					v-on:sortChanged="sortChanged"
					:rowData="rowData"
					:columnDefs="columnDefs"
					:with-tabs="true"
					:with-header="true"
					:with-short-description="true"
				></ag-item>
				<Pagination
					:totalNum="totalNum"
					:pageSize="pageSize"
					:sizeChange="sizeChange"
					:currentChange="currentChange"
					:currentPage="page"
				></Pagination>
			</div>
			<DebtorIpuFilter @apply-filter="applyFilter"/>
		</div>
	</div>
</template>
<script>
import AgItem from "@/components/templates/agGrid/AgItem.vue";

import {debtorIpuApi} from "@/common/api/debtorIpuApi";
import {enumDef} from "@/common/enumDefs";
import DebtorIpuFilter from "./DebtorIpuFilter";
import PaginationParent from "@/components/templates/common/PaginationParent.vue";

import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import Pagination from "@/components/templates/common/Pagination";
import QuickEnumFilterGroup from "@/components/newFilter/quickFilters/QuickEnumFilterGroup.vue";

export default {
	extends: PaginationParent,
	props: {
		tabInfo: Object
	},
	components: { QuickEnumFilterGroup, AgItem, DebtorIpuFilter, Pagination },
	data() {
		return {
			rowData: null,
			columnDefs: [],
			gridApi: null,
			sendData: "",
			quickFilters: [],
			columnFilters: [],
			sorting: [],
			enumDef: enumDef
		};
	},
	beforeMount() {
		this.setColumnDefs();
	},
	methods: {
		applyFilter(filters) {
			this.columnFilters = filters;
		},
		applyQuickFilter(filters) {
			this.quickFilters = filters;
		},
		getGridApi(gApi) {
			this.gridApi = gApi;
		},
		showConfirm() {
			const msg = this.$t("debtor.ipuTableWithFilter.confirmText");
			const selectData = this.gridApi.getSelectedRows();
			if (!(selectData && selectData.length > 0)) {
				this.toast(this.$t("debtor.ipuTableWithFilter.confirm.needSelection"));
				return;
			}
			let option = {
				title: "",
				msg: msg,
				confirmFun: this.confitrmIpu,
				params: selectData
			};
			this.confirmMeg(option, true);
		},
		showConfirmItem(data) {
			const msg = this.$t("debtor.ipuTableWithFilter.confirmText");
			let option = {
				title: "",
				msg: msg,
				confirmFun: this.confitrmIpu,
				params: [data]
			};
			this.confirmMeg(option, true);
		},
		confitrmIpu(data) {
			const option = data.map(item => {
				return item.id;
			});
			debtorIpuApi
				.confirm(option)
				.then(res => {
					if (res) {
						this.toastSuccess(res.msg);
						this.getList();
					}
				})
				.catch(err => {
					this.toast(err);
				});
		},
		setColumnDefs() {
			this.columnDefs = [
				{
					minWidth: 50,
					maxWidth: 50,
					checkboxSelection: true,
					pinned: "left",
					headerCheckboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true
				},
				{
					headerName: this.$t("common.supplier"),
					minWidth: 200,
					field: "supplierName",
					nameType: "supplierName",
					idType: "supplierId",
					cellRendererFramework: "CompanyTem",
					sortable: true
				},
				{
					headerName: this.$t("debtor.ipuTableWithFilter.requestFrom"),
					minWidth: 200,
					field: "sellerName",
					nameType: "sellerName",
					idType: "sellerId",
					cellRendererFramework: "CompanyTem",
					sortable: true
				},

				{
					headerName: this.$t("DebtorIpuTableWithFilter.Invoice.document"),
					field: "invoiceNumber",
					cellRendererFramework: "ItemDetail",
					sortable: true,
				},
				{
					headerName: this.$t("seller.upload.table.header.receivableAmount"),
					headerClass: "align-right",
					field: "amount",
					cellStyle: { "justify-content": "flex-end" },
					valueFormatter: asMoneyAmount(),
					minWidth: 100,
					maxWidth: 200,
					sortable: true
				},
				{
					headerName: this.$t("common.ccy"),
					field: "currency",
					sortable: true
				},
				{
					headerName: this.$t("seller.upload.table.header.dueDate"),
					field: "dueDate",
					valueFormatter: asLocalizedDate(),
					sortable: true
				},
				{
					headerName: this.$t("seller.upload.table.header.ibanPayment"),
					minWidth: 200,
					field: "iban",
					sortable: true
				},
				{
					headerName: this.$t("seller.upload.table.header.bicPayment"),
					field: "bic",
					sortable: true
				},
				{
					headerName: this.$t("seller.upload.table.header.receivableStatus"),
					field: "status",
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.ipuRequestStatus
				},
				{
					headerName: "",
					cellRendererFramework: "DebtorConfirmBtn",
					params: {
						showConfirm: this.showConfirmItem
					}
				}
			];
		},
		sortChanged(sortData) {
			this.sorting = sortData;
			this.initPage();
			this.getList();
		},
		getList() {
			let postData = {
				columns: [],
				filters: this.filters || [],
				maxResults: this.maxResults,
				offset: this.offset,
				sorting: this.sorting
			};

			debtorIpuApi
				.list(postData)
				.then(res => {
					if (res) {
						this.setTotalNum(res.recordsTotal);
						this.rowData = res.data.map(item => {
							return {
								...item,
								// Index has to be set to allow rows to expand
								index: ""
							};
						});
					}
				})
				.catch(err => {
					this.toast(err);
				});
		}
	},
	computed: {
		filters() {
			return [...this.columnFilters, ...this.quickFilters];
		}
	},
	watch: {
		filters() {
			this.getList();
		}
	},
};
</script>
